const audaTargetDamageAreaMappings = {
  A_CentreFront: 'Centre - Front Bumper',
  A_CentreFront__1: 'Centre - Front Bonnet',
  B_RHFront: 'Right - Front',
  Bonnet_1_: 'Bonnet',
  Bottom_Seal_Left: 'Bottom Seal - Left',
  Bottom_Seal_Right: 'Bottom Seal - Right',
  C_RHSide: 'Right - Door 1',
  C_RHSide__1: 'Right - Door 2',
  C_RHSide__2: 'Right - Door Post',
  Cab_Roof: 'Cab - Roof',
  Cab_Roof_Section: 'Cab Roof Section',
  Cab_Wheel_1_Left: 'Cab Wheel 1 - Left',
  Cab_Wheel_1_Right: 'Cab Wheel 1 - Right',
  Cab_Wheel_2_Left: 'Cab Wheel 2 - Left',
  Cab_Wheel_2_Right: 'Cab Wheel 2 - Right',
  Cab_Wheel_3_Left: 'Cab Wheel 3 - Left',
  Cab_Wheel_3_Right: 'Cab Wheel 3 - Right',
  Cab_Wheel_Mount_Left: 'Cab Wheel Mount - Left',
  Cab_Wheel_Mount_Right: 'Cab Wheel Mount - Right',
  D_RHRear: 'Right - Rear',
  D_RHRear__1: 'Right - Rear Door',
  Door_Glass_Left: 'Door Glass - Left',
  Door_Glass_Right: 'Door Glass - Right',
  Door_Left: 'Door - Left',
  Door_Right: 'Door - Right',
  E_CentreRear: 'Centre - Rear',
  E_CentreRear__1: 'Trunk/Tailgate',
  E_CentreRear__2: 'Centre - Rear Left',
  Exhaust_Pipe_Left: 'Exhaust Pipe - Left',
  Exhaust_Pipe_RIght: 'Exhaust Pipe - Right',
  F_LHRear: 'Left - Rear',
  F_LHRear__1: 'Rear Passenger Door',
  Fornt_Light_Left: 'Front Light - Left',
  Front_Bumper_1_: 'Front Bumper',
  Front_Grill: 'Front - Grill',
  Front_Light_Right: 'Front Light - Right',
  Front_Wing_Left: 'Front Wing - Left',
  Front_Wing_Right: 'Front Wing - Right',
  Fuel_Box_Left: 'Fuel Box - Left',
  Fuel_Box_Right: 'Fuel Box - Right',
  G_LHSide: 'Left - Door 1',
  G_LHSide__1: 'Left - Door 2',
  G_LHSide__2: 'Left - Door Post',
  H_LHFront: 'Left - Front',
  I_Roof: 'Centre - Roof',
  I_Roof__1: 'Right - Roof',
  I_Roof__2: 'Left - Roof',
  L_Underbody: 'Left - Underbody',
  L_Underbody__1: 'Right - Underbody',
  Left_Back_Window: 'Left - Back Window',
  Left_Door_Glass: 'Left - Door 1 Glass',
  Left_Front_Light: 'Left - Front Light',
  Left_Front_Lights: 'Left - Front Lights',
  Left_Front_Window: 'Left - Front Window',
  Left_Headlight: 'Left - Headlight',
  Left_Middle_Window: 'Left - Middle Window',
  Left_Rear_Light: 'Left - Rear Light',
  Left_Rear_Lights: 'Left - Rear Lights',
  Left_Rear_Window: 'Left - Rear Window',
  Left_Secondary_Door_Glass: 'Left - Door 2 Glass',
  Left_Window: 'Left - Window',
  Load_Area: 'Load Area',
  Load_Left: 'Load - Left',
  Load_Rear: 'Load - Rear',
  Load_Right: 'Load - Right',
  Load_Roof: 'Load - Roof',
  Load_Wheel_1_Left: 'Load Wheel 1 - Left',
  Load_Wheel_1_Right: 'Load Wheel 1 - Right',
  Load_Wheel_2_Left: 'Load Wheel 2 - Left',
  Load_Wheel_2_Right: 'Load Wheel 2 - Right',
  Load_Wheel_3_Left: 'Load Wheel 3 - Left',
  Load_Wheel_3_Right: 'Load Wheel 3 - Right',
  Load_Wheel_Mount_Left: 'Load Wheel Mount - Left',
  Load_Wheel_Mount_Right: 'Load Wheel Mount - Right',
  N_Glass: 'Windshield',
  P_RHMirror: 'Right - Mirror',
  Q_LHMirror: 'Left - Mirror',
  Rear_Bumper: 'Rear Bumper',
  Rear_Left_Light: 'Rear - Left Light',
  Rear_Light_Left: 'Rear Light - Left',
  Rear_Light_Right: 'Rear Light - Right',
  Rear_Panel_Left: 'Rear Panel - Left',
  Rear_Right: 'Rear - Right',
  Rear_Right_Light: 'Rear - Right Light',
  Rear_Window: 'Rear - Window',
  Rear_Windscreen: 'Rear - Windscreen',
  Right_Back_Window: 'Right - Rear Light',
  Right_Door_Glass: 'Right - Door 1 Glass',
  Right_Front_Light: 'Right - Front Light',
  Right_Front_Lights: 'Right - Front Lights',
  Right_Front_Window: 'Right - Front Window',
  Right_Headlight: 'Right - Headlight',
  Right_Middle_Window: 'Right - Middle Window',
  Right_Rear_Light: 'Right - Rear Light',
  Right_Rear_Lights: 'Right - Rear Lights',
  Right_Rear_Window: 'Right - Rear Window',
  Right_Secondary_Door_Glass: 'Right - Door 2 Glass',
  Right_Window: 'Right - Window',
  Roof_Glass_Left: 'Roof Glass - Left',
  Roof_Glass_Right: 'Roof Glass - Right',
  Roof_Left: 'Roof - Left',
  Roof_Right_1_: 'Roof - Right',
  S_RHFrontWheel: 'Right - Front Wheel',
  Stairs_Left: 'Stairs - Left',
  Stairs_Right: 'Stairs - Right',
  T_LHFrontWheel: 'Left - Front Wheel',
  U_RHRearWheel: 'Right - Rear Wheel',
  V_LHRearWheel: 'Left - Rear Wheel',
  Windscreen_1_: 'Windscreen',
  Wing_Mirror_Left: 'Wing Mirror - Left',
  Wing_Mirror_Right: 'Wing Mirror - Right',
};

export default audaTargetDamageAreaMappings;
